import { render, staticRenderFns } from "./CoverPage.vue?vue&type=template&id=1b8ed66a"
import script from "./CoverPage.vue?vue&type=script&lang=js"
export * from "./CoverPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports